import { classNames } from "@ember-decorators/component";
import { and } from "truth-helpers";
import UserStatusMessage from "discourse/components/user-status-message";
import avatar from "discourse/helpers/avatar";
import icon from "discourse/helpers/d-icon";
import decorateUsernameSelector from "discourse/helpers/decorate-username-selector";
import formatUsername from "discourse/helpers/format-username";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const EmailGroupUserChooserRow = dt7948.c(class EmailGroupUserChooserRow extends SelectKitRowComponent {
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.item.isUser}}\n      {{avatar this.item imageSize=\"tiny\"}}\n      <div>\n        <span class=\"identifier\">{{formatUsername this.item.id}}</span>\n        <span class=\"name\">{{this.item.name}}</span>\n      </div>\n      {{#if (and this.item.showUserStatus this.item.status)}}\n        <UserStatusMessage @status={{this.item.status}} @showDescription={{true}} />\n      {{/if}}\n      {{decorateUsernameSelector this.item.id}}\n    {{else if this.item.isGroup}}\n      {{icon \"users\"}}\n      <div>\n        <span class=\"identifier\">{{this.item.id}}</span>\n        <span class=\"name\">{{this.item.full_name}}</span>\n      </div>\n    {{else}}\n      {{icon \"envelope\"}}\n      <span class=\"identifier\">{{this.item.id}}</span>\n    {{/if}}\n  ", {
      strictMode: true,
      scope: () => ({
        avatar,
        formatUsername,
        and,
        UserStatusMessage,
        decorateUsernameSelector,
        icon
      })
    }), this);
  }
}, [classNames("email-group-user-chooser-row")]);
export default EmailGroupUserChooserRow;